// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__218Te","newExpiryDate":"styles_newExpiryDate__3Pvey","footer":"styles_footer__1kVwb"};